import React from "react";
import Slider from "react-slick";
import residentialImg from "../img/envision/homeservices/banner/banner1.jpg";
import cmImg from "../img/envision/homeservices/banner/banner3.jpg";
// import hospitalityImg from "../img/envision/homeservices/banner/home-b4.jpg";
import sshImg from "../img/envision/homeservices/banner/banner2.jpg";
import specialtyImg from "../img/envision/homeservices/banner/home-b5.jpg";
import galleryImg6 from "../img/envision/homeservices/banner/landingtwo.jpeg";
import galleryImg7 from "../img/envision/homeservices/banner/landingone.jpeg";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const GallerySlider = () => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    pauseOnHover: true,
    arrows: true, // Disable next/prev arrows
  };

  return (
    <section style={{ backgroundColor: "#dae2e3" }}>
      <div className="container-fluid" style={{ padding: "0px", overflow: "hidden" }}>
        <div className="row">
          <div className="col-lg-12">
            <Slider {...settings}>
              <div className="item">
                <section
                  className="breadcumb"
                  aria-label="breadcumb"
                  style={{
                    backgroundImage: `url(${residentialImg})`,
                    height: "750px", // Increased height for image
                    backgroundSize: "cover", // Ensure the image covers the section
                    backgroundPosition: "center", // Center the image
                  }}
                >
                  <div className="container-fluid">
                    <div className="row">
                      <div className="col-12">
                        <div className="main">
                          <div className="bread">
                            {/* <div className="bread-title" style={{ fontSize: '2.5rem', fontWeight: '700', letterSpacing: '2px', display: 'block' }}>The Leading Service Provider
                            </div> */}

                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
              </div>
              <div className="item">
                <section
                  className="breadcumb"
                  aria-label="breadcumb"
                  style={{
                    backgroundImage: `url(${cmImg})`,
                    height: "750px",
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    marginTop: "50px"
                  }}
                >
                  <div className="container-fluid">
                    <div className="row">
                      <div className="col-12">
                        <div className="main">
                          <div className="bread">


                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
              </div>

              {/* <div className="item">
                <section
                  className="breadcumb"
                  aria-label="breadcumb"
                  style={{
                    backgroundImage: `url(${hospitalityImg})`,
                    height: "750px", 
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                  }}
                >
                  <div className="container-fluid">
                    <div className="row">
                      <div className="col-12">
                        <div className="main">
                          <div className="bread">
                        

                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
              </div> */}
              <div className="item">
                <section
                  className="breadcumb"
                  aria-label="breadcumb"
                  style={{
                    backgroundImage: `url(${sshImg})`,
                    height: "750px", // Increased height for image
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                  }}
                >
                  <div className="container-fluid">
                    <div className="row">
                      <div className="col-12">
                        <div className="main">
                          <div className="bread">
                            {/* <div className="bread-title" style={{ fontSize: '2.5rem', fontWeight: '700', letterSpacing: '2px', display: 'block', color: '#fff' }}>Your Next Great Experience Starts Here.
                            </div> */}

                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
              </div>



              <div className="item">
                <section
                  className="breadcumb"
                  aria-label="breadcumb"
                  style={{
                    backgroundImage: `url(${specialtyImg})`,
                    height: "750px",
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                  }}
                >
                  <div className="container-fluid">
                    <div className="row">
                      <div className="col-12">
                        <div className="main">
                          <div className="bread">


                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
              </div>
              {/* <div className="item">
                <section
                  className="breadcumb"
                  aria-label="breadcumb"
                  style={{
                    backgroundImage: `url(${galleryImg6})`,
                    height: "750px", // Increased height for image
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                  }}
                >
                  <div className="container-fluid">
                    <div className="row">
                      <div className="col-12">
                        <div className="main">
                          <div className="bread">


                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
              </div> */}
              <div className="item">
                <section
                  className="breadcumb"
                  aria-label="breadcumb"
                  style={{
                    backgroundImage: `url(${galleryImg7})`,
                    height: "750px", // Increased height for image
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                  }}
                >
                  <div className="container-fluid">
                    <div className="row">
                      <div className="col-12">
                        <div className="main">
                          <div className="bread">


                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
              </div>
            </Slider>
          </div>
        </div>
      </div>
    </section>
  );
};

export default GallerySlider;
